import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"

import Contacts from "components/Contacts"

const ContactsPage = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Planhopper | Contactos</title>
      </Helmet>
      <Container fluid>
        <Contacts />
      </Container>
    </div>
  )
}

export default ContactsPage
